<template lang="pug">
div( style="object-fit: contain; width: 100%; max-height: 100%; height: 100%;")
    .buttons
      button.btn.btn-sm(@click="$refs.zoomer.zoomIn()") +
      button.btn.btn-sm(@click="$refs.zoomer.zoomOut()") -
    .buttons2
      button.btn.btn-sm  
        router-link(:to="`/detail/${id}`"): svg(viewBox="0 0 24 24")
          path(fill="currentColor", d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z")
      button.btn.btn-sm  
        router-link(to="/menu"): svg(viewBox="0 0 24 24")
          path(fill="currentColor", d="M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z")
      button.btn.btn-sm  
        router-link(to="/"): svg(viewBox="0 0 24 24")
          path(fill="currentColor", d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z")
    router-link.btn.btn-sm.btn-right(type="button" :to="`/image/${id}/${parseInt(page)-1}`" v-if="page != 1")  
      svg(xmlns="http://www.w3.org/2000/svg", viewBox="0 0 24 24")
        path(d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z")

    router-link.btn.btn-sm.btn-left(type="button" :to="`/image/${id}/${parseInt(page)+1}`" v-if="page != 4")  
      svg(xmlns="http://www.w3.org/2000/svg", viewBox="0 0 24 24")
        path(d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z")


    v-zoomer(
      ref="zoomer",
      :style="{width: w+'px', height: h+'px'}",
      :aspect-ratio="imageAspectRatio",
      :max-scale="10",
      :zooming-elastic="false",
      :doubleClickToZoom="false",
      :mouseWheelToZoom="false"
    )
      img(:src="require(`@/assets/img/hq/${id}-${page}-hq.jpg`)", style="object-fit: contain; width: 100%; height: 100%; margin-top: 20px;", @load="onImageLoad")
</template>

<script>
export default {
  props: ['id', 'page'],
  data () {
    return {
      imageAspectRatio: 1,
      w: window.innerWidth,
      h: window.innerHeight-20,
    }
  },
  mounted(){
    this.$toast.show("Um das Bild zu vergrößern, nutzen Sie bitte die '+' und '-' Buttons und verschieben das Bild.", {position: "bottom", duration: 5000});
  },
  methods: {
    onImageLoad(e) {
      const img = e.target
      this.imageAspectRatiox = img.naturalWidth / img.naturalHeight
    },
  },
}
</script>

<style scoped>
img {
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
}
.buttons{
  bottom: 10px;
  right: 20px;
  position: absolute;
  z-index: 99;
}
.buttons2{
  top: 10px;
  right: 20px;
  position: absolute;
  z-index: 99;
}
@media (max-width: 1000px) {
  .btn-sm{
    padding: 0px;
  }
  .buttons{
    bottom: 70px;

  }
}
</style>
